/** Copies text with the async Clipboard API; `false` when the browser refuses (no permission, http). */
export const copyText = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
};
